import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'nobreak',
  standalone: false
})
export class NonBreakingPipe implements PipeTransform {
  transform(value: string) {
    return (value) ? value.replace(/ /g, '\u00a0') : value;
  }
}
